(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // Rotating announcement in the middle of the logo bar.
  class HeaderAnnouncement extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.hann__item'));
      if (this.items.length === 0) return;

      this.isTicker = this.dataset.animation === 'ticker';

      if (this.isTicker) {
        this.setupTicker();
        return;
      }

      this.index = Math.max(
        0,
        this.items.findIndex((item) => item.classList.contains('is-active'))
      );

      const prev = this.querySelector('[data-hann-prev]');
      const next = this.querySelector('[data-hann-next]');

      if (prev) {
        prev.addEventListener('click', () => {
          this.select(this.index - 1, 'prev');
          this.play();
        });
      }

      if (next) {
        next.addEventListener('click', () => {
          this.select(this.index + 1, 'next');
          this.play();
        });
      }

      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.play());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.play());

      this.onBlockSelect = (event) => {
        const index = this.items.findIndex((item) => item.dataset.blockId === event.detail.blockId);
        if (index > -1) {
          this.select(index, index < this.index ? 'prev' : 'next');
          this.pause();
        }
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', () => this.play());

      this.play();
    }

    disconnectedCallback() {
      this.pause();
      if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    // Duplicates the messages once so the marquee can loop seamlessly.
    setupTicker() {
      const list = this.querySelector('.hann__list');
      if (!list || this.dataset.ticker === 'ready') return;

      const originals = Array.from(list.children);
      if (originals.length === 0) return;

      originals.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-block-id');
        clone.removeAttribute('id');
        list.appendChild(clone);
      });

      const speed = parseFloat(this.dataset.speed) || 5;
      list.style.setProperty('--hann-ticker-dur', Math.max(12, originals.length * speed) + 's');
      this.dataset.ticker = 'ready';
    }

    select(target, direction) {
      const total = this.items.length;
      const index = ((target % total) + total) % total;

      this.dataset.dir = direction === 'prev' ? 'prev' : 'next';
      this.items.forEach((item, i) => item.classList.toggle('is-active', i === index));
      this.index = index;
    }

    play() {
      this.pause();
      if (this.isTicker) return;
      if (this.items.length < 2) return;
      if (this.dataset.autoplay !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const speed = parseFloat(this.dataset.speed) || 5;
      this.timer = setInterval(() => this.select(this.index + 1, 'next'), speed * 1000);
    }

    pause() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  if (!customElements.get('header-announcement')) {
    customElements.define('header-announcement', HeaderAnnouncement);
  }

  // Keeps the overlap of the transparent navigation row exact.
  (function () {
    const root = document.documentElement;

    function set(name, element) {
      if (!element) return;
      const height = `${Math.round(element.getBoundingClientRect().height)}px`;
      if (root.style.getPropertyValue(name) !== height) {
        root.style.setProperty(name, height);
      }
    }

    function measure() {
      set('--hdr-nav-height', document.querySelector('.site-header__main'));
      set('--hdr-full-height', document.querySelector('.site-header'));
    }

    measure();
    window.addEventListener('load', measure);
    window.addEventListener('resize', measure);
    window.addEventListener('orientationchange', () => setTimeout(measure, 250));
    document.addEventListener('shopify:section:load', measure);

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(measure);
      const nav = document.querySelector('.site-header__main');
      const shell = document.querySelector('.site-header');
      if (nav) observer.observe(nav);
      if (shell) observer.observe(shell);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
